
				var addMethods = require("../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["getTasks","setTaskCountByDay","getTasksByWeek"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "c01c31eb0ae58f10a280.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			